module.exports = __webpack_public_path__ + "static/img/preview-04.5147a0ed.webp";